var _stepper2, _stepper3, _stepper4, _stepper5;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/components/stepper.ts
import { createMultiStyleConfigHelpers, cssVar } from "@chakra-ui/styled-system";

var _createMultiStyleConf = createMultiStyleConfigHelpers(["stepper", "step", "title", "description", "indicator", "separator", "icon", "number"]),
    defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
    definePartsStyle = _createMultiStyleConf.definePartsStyle;

var $size = cssVar("stepper-indicator-size");
var $iconSize = cssVar("stepper-icon-size");
var $titleFontSize = cssVar("stepper-title-font-size");
var $descFontSize = cssVar("stepper-description-font-size");
var $accentColor = cssVar("stepper-accent-color");
var baseStyle = definePartsStyle(function (_ref) {
  var _stepper;

  var c = _ref.colorScheme;
  return {
    stepper: (_stepper = {
      display: "flex",
      justifyContent: "space-between",
      gap: "4",
      "&[data-orientation=vertical]": {
        flexDirection: "column",
        alignItems: "flex-start"
      },
      "&[data-orientation=horizontal]": {
        flexDirection: "row",
        alignItems: "center"
      }
    }, _defineProperty(_stepper, $accentColor.variable, "colors.".concat(c, ".500")), _defineProperty(_stepper, "_dark", _defineProperty({}, $accentColor.variable, "colors.".concat(c, ".200"))), _stepper),
    title: {
      fontSize: $titleFontSize.reference,
      fontWeight: "medium"
    },
    description: {
      fontSize: $descFontSize.reference,
      color: "chakra-subtle-text"
    },
    number: {
      fontSize: $titleFontSize.reference
    },
    step: {
      flexShrink: 0,
      position: "relative",
      display: "flex",
      gap: "2",
      "&[data-orientation=horizontal]": {
        alignItems: "center"
      },
      flex: "1",
      "&:last-of-type:not([data-stretch])": {
        flex: "initial"
      }
    },
    icon: {
      flexShrink: 0,
      width: $iconSize.reference,
      height: $iconSize.reference
    },
    indicator: {
      flexShrink: 0,
      borderRadius: "full",
      width: $size.reference,
      height: $size.reference,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&[data-status=active]": {
        borderWidth: "2px",
        borderColor: $accentColor.reference
      },
      "&[data-status=complete]": {
        bg: $accentColor.reference,
        color: "chakra-inverse-text"
      },
      "&[data-status=incomplete]": {
        borderWidth: "2px"
      }
    },
    separator: {
      bg: "chakra-border-color",
      flex: "1",
      "&[data-status=complete]": {
        bg: $accentColor.reference
      },
      "&[data-orientation=horizontal]": {
        width: "100%",
        height: "2px",
        marginStart: "2"
      },
      "&[data-orientation=vertical]": {
        width: "2px",
        position: "absolute",
        height: "100%",
        maxHeight: "calc(100% - ".concat($size.reference, " - 8px)"),
        top: "calc(".concat($size.reference, " + 4px)"),
        insetStart: "calc(".concat($size.reference, " / 2 - 1px)")
      }
    }
  };
});
var stepperTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: {
    xs: definePartsStyle({
      stepper: (_stepper2 = {}, _defineProperty(_stepper2, $size.variable, "sizes.4"), _defineProperty(_stepper2, $iconSize.variable, "sizes.3"), _defineProperty(_stepper2, $titleFontSize.variable, "fontSizes.xs"), _defineProperty(_stepper2, $descFontSize.variable, "fontSizes.xs"), _stepper2)
    }),
    sm: definePartsStyle({
      stepper: (_stepper3 = {}, _defineProperty(_stepper3, $size.variable, "sizes.6"), _defineProperty(_stepper3, $iconSize.variable, "sizes.4"), _defineProperty(_stepper3, $titleFontSize.variable, "fontSizes.sm"), _defineProperty(_stepper3, $descFontSize.variable, "fontSizes.xs"), _stepper3)
    }),
    md: definePartsStyle({
      stepper: (_stepper4 = {}, _defineProperty(_stepper4, $size.variable, "sizes.8"), _defineProperty(_stepper4, $iconSize.variable, "sizes.5"), _defineProperty(_stepper4, $titleFontSize.variable, "fontSizes.md"), _defineProperty(_stepper4, $descFontSize.variable, "fontSizes.sm"), _stepper4)
    }),
    lg: definePartsStyle({
      stepper: (_stepper5 = {}, _defineProperty(_stepper5, $size.variable, "sizes.10"), _defineProperty(_stepper5, $iconSize.variable, "sizes.6"), _defineProperty(_stepper5, $titleFontSize.variable, "fontSizes.lg"), _defineProperty(_stepper5, $descFontSize.variable, "fontSizes.md"), _stepper5)
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export { stepperTheme };